export default {
  saveRef: function saveRef(name) {
    var _this = this;

    return function (node) {
      _this[name] = node;
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/rc-tabs/es/RefMixin.js
// module id = 1713
// module chunks = 0